<template>
    <section class="form-container">
        <SpinnerItem v-if="isLoading" />
        <form v-if="!isLoading" class="middle" @submit="submitCatch">
            <ImageContainer :pictures="catchDetails.images" ownerType="catch" />
            <CatcherSelector :catcher="catchDetails.catcher" @updateCatcher="onCatcherUpdate" />
            <SpeciesSelector :species="catchDetails.species" @updateSpecies="onSpeciesUpdate" />
            <RegionSelector :region="catchDetails.region" @updateRegion="onRegionUpdate" />
            <div class="field">
                <label class="label">Dato</label>
                <div class="control">
                    <input
                        v-model="catchDetails.date"
                        class="input text"
                        type="datetime-local"
                        required
                        min="1920-01-01T00:00"
                        max="2120-01-01T00:00"
                    />
                </div>
            </div>
            <div class="field">
                <label class="label">Vekt</label>
                <div class="control">
                    <input
                        v-model="catchDetails.weight"
                        class="input text"
                        type="number"
                        placeholder="Vekt i gram"
                        pattern="[0-9]{1.7}"
                        step="1"
                        required
                    />
                </div>
            </div>
            <div class="field">
                <label class="label">Historie</label>
                <div class="control">
                    <textarea
                        v-model="catchDetails.description"
                        placeholder="Hva skjedde?"
                        class="input"
                    />
                </div>
            </div>

            <div class="field">
                <div class="button-container">
                    <button type="submit" class="button">Lagre fangst</button>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SpinnerItem from '../common/SpinnerItem.vue';
import RegionSelector from '../regions/RegionSelector.vue';
import SpeciesSelector from '../species/SpeciesSelector.vue';
import CatcherSelector from '../catchers/CatcherSelector.vue';
import ImageContainer from '../common/ImageContainer.vue';
import api from '../../common/api';
import url from '../../common/url';
import { Bus, Stops } from '../../common/bus';

// todo: should not upload image on change

export default {
    props: ['id'],
    components: {
        SpinnerItem,
        CatcherSelector,
        RegionSelector,
        SpeciesSelector,
        ImageContainer,
    },
    data() {
        return {
            isLoading: false,
            uploadingCatch: false,
            catchDetails: {
                id: 0,
                date: new Date().toJSON().slice(0, 16),
                region: null,
                catcher: null,
                species: null,
                images: [],
            },
        };
    },
    computed: {
        ...mapState('session', ['profile', 'lastCatch']),
    },
    created() {
        Bus.$emit(Stops.NAVBAR, 'None');
        Bus.$on(Stops.DATE_PARSED, this.onDateParsed);
        Bus.$on(Stops.GPS_PARSED, this.onGpsParsed);
        if (this.id) this.loadCatch(this.id);
        else if (this.lastCatch.id) {
            this.catchDetails.catcher = this.lastCatch.catcher;
            this.catchDetails.species = this.lastCatch.species;
            this.catchDetails.region = this.lastCatch.region;
        }
    },
    beforeDestroy() {
        Bus.$off(Stops.DATE_PARSED, this.onDateParsed);
        Bus.$off(Stops.GPS_PARSED, this.onGpsParsed);
    },

    methods: {
        ...mapMutations('session', ['setLastCatch']),
        ...mapMutations('catches', ['clearCache']),
        onDateParsed(date) {
            if (!this.id) this.catchDetails.date = date;
        },
        onGpsParsed(position) {
            this.catchDetails.position = position;
        },
        onCatcherUpdate(catcher) {
            this.catchDetails.catcher = catcher;
        },
        onRegionUpdate(region) {
            this.catchDetails.region = region;
        },
        onSpeciesUpdate(species) {
            this.catchDetails.species = species;
        },
        async loadCatch(id) {
            this.isLoading = true;
            const details = await api.get(url.getCatch(id));
            this.isLoading = false;
            if (details.error) return;
            details.date = details.date.substring(0, 16);
            this.catchDetails = details;
        },
        async submitCatch(event) {
            event.preventDefault();
            const uri = this.id ? url.getCatch(this.id) : url.getCatches();
            let details = null;
            this.isLoading = true;
            if (this.id) details = await api.put(uri, this.catchDetails);
            else {
                details = await api.post(uri, this.catchDetails);
                this.clearCache();
            }
            this.isLoading = false;
            if (details.error) return;
            this.catchDetails = details;
            this.setLastCatch(details);
            Bus.$emit(Stops.TOAST, 'Fangst lagret');
            Bus.$emit(Stops.UPLOAD_IMAGE, { ownerId: details.id });
            this.$router.push({ name: 'Catches' });
        },
    },
};
</script>

<style lang="scss">
$borderColor: rgb(230, 230, 230);
.form-container {
    display: flex;
    max-width: $maxContentWidth;
    font-size: 1.2rem;
    .middle {
        flex: 1;
        max-width: $maxContentWidth/3;
        margin: auto;
    }
    .field {
        padding: 0.3rem;
        display: flex;
        flex-direction: column;
        line-height: 2rem;
        width: 100%;
        .input {
            width: 100%;
            padding: 0.5rem 0.5rem 0.5rem 0.6rem;
            margin: 0.2rem 0;
            border: 1px solid $borderColor;
            border-radius: 4px;
            line-height: 1.4rem;
            box-sizing: border-box;
            transition: all 0.2s ease-in-out;
            &:hover {
                border: 1px solid $borderColorActive;
            }
        }
        .label {
            display: flex;
            span {
                flex: 1;
            }
        }
        .text,
        .select {
            height: 36px;
        }
    }

    .select-container {
        position: relative;
        i.fa-spinner {
            position: absolute;
            right: 0.4rem;
            top: 0.6rem;
            background-color: white;
        }
    }

    .button-container {
        display: flex;
        width: 100%;
        button {
            line-height: 2em;
            font-size: 1.2rem;
            border: 0;
            width: 100%;
            background-color: white;
            color: black;
            text-decoration: none;
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            border: 1px solid white;
            border-radius: 4px;
            &:hover {
                border: 1px solid $borderColorActive;
            }
        }
    }

    @mixin keyframes($name) {
        @-webkit-keyframes #{$name} {
            @content;
        }
        @-moz-keyframes #{$name} {
            @content;
        }
        @-ms-keyframes #{$name} {
            @content;
        }
        @keyframes #{$name} {
            @content;
        }
    }

    .loader-container {
        display: flex;
        height: 80vh;
        flex: 1;
        justify-content: center;
        align-items: center;
        .loader {
            border: 1rem solid #fafafa;
            border-top: 1rem solid #f0f0f0;
            border-radius: 50%;
            width: 7rem;
            height: 7rem;
            animation: spin 1s linear infinite;
            @include keyframes(spin) {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        }
    }
}
</style>
